import { render, staticRenderFns } from "./ActivityEventPage.vue?vue&type=template&id=ce66dda6"
import script from "./ActivityEventPage.vue?vue&type=script&lang=js"
export * from "./ActivityEventPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports